import sliderOne from "./images/1.jpg";
import sliderTwo from "./images/2.jpg";
import sliderThere from "./images/3.jpg";

export const images = [
  {
    title: "sliderOne",
    subtitle: "ti0H-bvMi3I",
    img: sliderOne,
  },
  {
    title: "sliderTwo",
    subtitle: "UUkn-enk2RU",
    img: sliderTwo,
  },
  {
    title: "sliderThere",
    subtitle: "uC9qU3X1JgM",
    img: sliderThere,
  },
];
